import DNSDAddressContainer from './DNSDAddressContainer'

export default DNSDAddressContainer;